import {
  ILoginResponse,
  IUserLoginResponse,
} from "../api/services/auth/models";
import { IMyInfoData } from "../api/services/profile/models";
import { setRefreshToken } from "./api";
import { AuthConfig } from "./config/authConfig";
import { EVENT_LOCAL_STORAGE_LOGIN } from "./events";

const calculateExpiryDate = (expiresIn: number) => {
  const time = new Date();
  time.setSeconds(time.getSeconds() + expiresIn);
  return time.toISOString();
};
const isExpired = () => {
  const now = new Date();
  const expiresAt = new Date(AuthConfig.getExpiresAt() || "");
  return expiresAt.getTime() - now.getTime() < 0;
};
export const getToken = async (): Promise<string | null> => {
  if (isExpired()) {
    await setRefreshToken();
  }
  return AuthConfig.getToken();
};

export const contextUserLogin = (data: IUserLoginResponse) => {
  AuthConfig.setUserInfo(data.user);
  AuthConfig.setToken(data.access_token);
  AuthConfig.setRefreshToken(data.refresh_token);
  data.expires_in &&
    AuthConfig.setExpiresAt(calculateExpiryDate(data.expires_in));
};

export const logOut = () => {
  AuthConfig.setUserInfo(null);
  AuthConfig.setToken(null);
  AuthConfig.setMyInfo(null);
  AuthConfig.setRefreshToken(null);
  AuthConfig.setExpiresAt(null);
  window.dispatchEvent(new Event(EVENT_LOCAL_STORAGE_LOGIN));
};
export const AppLogin = (data: ILoginResponse) => {
  AuthConfig.setAppToken(
    data.access_token,
    calculateExpiryDate(data.expires_in || 0)
  );
};
export const setUserProfileInfo = (data: IMyInfoData) => {
  AuthConfig.setMyInfo(data);
};

